//const futureTs = Math.round(new Date().getTime() / 1000) + 5000;

export const getunitStormOperation = () => {
  return null;
  // return {
  //   unit: "287eb8ff-1333-4890-8855-7c14a7cf63c9",
  //   id: "17b20271-f571-45e8-ae27-3ff124000f93",
  //   updates: [
  //     {
  //       scheduled: 1742637578,
  //     },
  //     {
  //       started: 1742637578,
  //     },
  //   ],
  //   last_update: 1742637578,
  //   created_by: "639f4ae5-41d4-49c3-bd5c-be68cfce857d",
  //   status: "started",
  //   created: 1742637577,
  //   priority: 55,
  //   source: "owner",
  //   started: 1742637578,
  //   battery: "storm",
  //   repeat: {
  //     sunday: {
  //       start: "00:00",
  //     },
  //     saturday: {
  //       start: "00:00",
  //     },
  //     tuesday: {
  //       start: "00:00",
  //     },
  //     wednesday: {
  //       start: "00:00",
  //     },
  //     thursday: {
  //       start: "00:00",
  //     },
  //     friday: {
  //       start: "00:00",
  //     },
  //     monday: {
  //       start: "00:00",
  //     },
  //     phday: {
  //       start: "00:00",
  //     },
  //   },
  //   scheduled: 1742637578,
  //   owner: "manual",
  //   end: futureTs,
  //   start: 1742637577,
  //   description: "Storm",
  // };
};

export const getSettingsStormOperation = () => {
  return [
    // {
    //   unit: "287eb8ff-1333-4890-8855-7c14a7cf63c9",
    //   updates: [
    //     {
    //       scheduled: 1742645544,
    //     },
    //     {
    //       started: 1742645544,
    //     },
    //   ],
    //   ev1_charger: "boost",
    //   last_update: 1742645544,
    //   created_by: "639f4ae5-41d4-49c3-bd5c-be68cfce857d",
    //   status: "started",
    //   created: 1742645542,
    //   priority: 55,
    //   source: "owner",
    //   started: 1742645544,
    //   repeat: {
    //     sunday: {
    //       start: "00:00",
    //     },
    //     saturday: {
    //       start: "00:00",
    //     },
    //     tuesday: {
    //       start: "00:00",
    //     },
    //     wednesday: {
    //       start: "00:00",
    //     },
    //     thursday: {
    //       start: "00:00",
    //     },
    //     friday: {
    //       start: "00:00",
    //     },
    //     monday: {
    //       start: "00:00",
    //     },
    //     phday: {
    //       start: "00:00",
    //     },
    //   },
    //   scheduled: 1742645544,
    //   owner: "manual",
    //   end: futureTs,
    //   id: "b414b8ea-71b7-4912-8e77-edafc8e0f5fd",
    //   start: 1742645543,
    //   description: "EV Boost",
    // },
    {
      unit: "287eb8ff-1333-4890-8855-7c14a7cf63c9",
      status: "pending",
      owner: "manual",
      created_by: "639f4ae5-41d4-49c3-bd5c-be68cfce857d",
      last_update: 1741057374,
      ev1_charger: "sun_soaker",
      top_up_window: {
        start: "11:00",
        end: "02:00"
      },
      source: "owner",
      priority: 20,
      repeat: {
        monday: {
          start: "00:00"
        },
        tuesday: {
          start: "00:00"
        },
        wednesday: {
          start: "00:00"
        },
        thursday: {
          start: "00:00"
        },
        friday: {
          start: "00:00"
        },
        saturday: {
          start: "00:00"
        },
        sunday: {
          start: "00:00"
        },
        phday: {
          start: "00:00"
        }
      },
      end: 2524608000,
      id: "577ffbff-7d4e-45ab-ab35-bb423b8fa366",
      start: 1741057374,
      created: 1741057374
    },
    // {
    //   unit: "287eb8ff-1333-4890-8855-7c14a7cf63c9",
    //   updates: [
    //   {
    //     scheduled: 1742638365,
    //   },
    //   ],
    //   ev1_charger: "charge",
    //   last_update: 1742638365,
    //   created_by: "639f4ae5-41d4-49c3-bd5c-be68cfce857d",
    //   status: "scheduled",
    //   created: 1742638364,
    //   priority: 56,
    //   source: "owner",
    //   repeat: {
    //   sunday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   saturday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   tuesday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   wednesday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   thursday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   friday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   monday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   phday: {
    //     start: "11:00",
    //     end: "14:00",
    //   },
    //   },
    //   scheduled: 1742638365,
    //   owner: "manual",
    //   end: 2524608000,
    //   id: "b2682f39-3b26-4691-89c1-754dffc9e07e",
    //   start: 1742638364,
    //   description: "EV Charge",
    // },
    // {
    //   unit: "287eb8ff-1333-4890-8855-7c14a7cf63c9",
    //   updates: [
    //     {
    //       scheduled: 1742637578,
    //     },
    //     {
    //       started: 1742637578,
    //     },
    //   ],
    //   last_update: 1742637578,
    //   created_by: "639f4ae5-41d4-49c3-bd5c-be68cfce857d",
    //   status: "started",
    //   created: 1742637577,
    //   priority: 55,
    //   source: "owner",
    //   started: 1742637578,
    //   battery: "storm",
    //   repeat: {
    //     sunday: {
    //       start: "00:00",
    //     },
    //     saturday: {
    //       start: "00:00",
    //     },
    //     tuesday: {
    //       start: "00:00",
    //     },
    //     wednesday: {
    //       start: "00:00",
    //     },
    //     thursday: {
    //       start: "00:00",
    //     },
    //     friday: {
    //       start: "00:00",
    //     },
    //     monday: {
    //       start: "00:00",
    //     },
    //     phday: {
    //       start: "00:00",
    //     },
    //   },
    //   scheduled: 1742637578,
    //   owner: "manual",
    //   end: futureTs,
    //   id: "17b20271-f571-45e8-ae27-3ff124000f93",
    //   start: 1742637577,
    //   description: "Storm",
    // },
  ];
};

export const createunitEvBoostOperation = () => {
  return null;
};
